import api from '../config/api';

export const subscriptionService = {
    // Get all subscriptions for the user
    getAllSubscriptions: async () => {
        try {
            const response = await api.get('/subscriptions');
            return response.data;
        } catch (error) {
            if (error.response?.status === 401) {
                throw { ...error, status: 401 };
            }

            // Network or other errors
            console.error('Subscription fetch error:', {
                code: error.code,
                status: error.response?.status,
                message: error.message,
                data: error.response?.data
            });

            // Rethrow the error with additional context
            throw {
                ...error,
                status: error.response?.status || 'NETWORK_ERROR',
                userMessage: 'Unable to connect to the server. Please check your connection and try again.'
            };
        }
    },

    // Add a new subscription
    addSubscription: async (subscriptionData) => {
        const response = await api.post('/subscriptions', subscriptionData);
        return response.data;
    },

    // Update a subscription
    updateSubscription: async (id, subscriptionData) => {
        const response = await api.put(`/subscriptions/${id}`, subscriptionData);
        return response.data;
    },

    // Delete a subscription
    deleteSubscription: async (id) => {
        const response = await api.delete(`/subscriptions/${id}`);
        return response.data;
    }
}; 